import ClickableIcon from "./ClickableIcon";
export default ClickableIcon;
